import { Check } from "lucide-react";

const MitKapszSection = () => {
  const deliverables = [
    "Teljes, kész szövegezés (headline-ok, alcímek, CTA-k, microcopy)",
    "Konverziós struktúra (szekciók sorrendje és szerepe)",
    "Bizalom-építő elemek (folyamat, gyakori kérdések, kifogáskezelés)",
    "Mobilra is optimalizálva (rövid, tiszta, azonnal érthető)",
    "Későbbi módosítás (pl. ha később kell több oldal, megoldható — de nem ezzel kezdünk)"
  ];

  return (
    <section id="mit-kapsz" data-testid="mit-kapsz-section" className="light-band-2 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-ink-text text-center">
            Kézzelfogható végeredmény —{" "}
            <span className="text-primary">nem "majd kész lesz"</span>
          </h2>

          {/* Dashboard panel */}
          <div className="scroll-animate mt-12 card-light rounded-3xl p-8 md:p-12">
            <div className="grid gap-4">
              {deliverables.map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-4 p-4 rounded-xl bg-soft-tint-a/50 hover:bg-soft-tint-a transition-colors"
                >
                  <div className="w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <Check size={14} className="text-accent" />
                  </div>
                  <p className="text-ink-text">{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Info panel - designed quote */}
          <div className="scroll-animate mt-12 relative">
            <div className="bg-gradient-to-br from-primary/5 via-accent/5 to-primary/5 rounded-3xl p-8 md:p-12 text-center border border-primary/10 relative overflow-hidden">
              {/* Decorative elements */}
              <div className="absolute top-4 left-6 text-6xl text-primary/10 font-serif leading-none" aria-hidden="true">"</div>
              <div className="absolute bottom-4 right-6 text-6xl text-primary/10 font-serif leading-none rotate-180" aria-hidden="true">"</div>
              
              <p className="font-sora text-xl md:text-2xl lg:text-3xl text-ink-text font-medium leading-relaxed max-w-3xl mx-auto relative z-10">
                Nem kell neked <span className="text-primary">"kitalálni"</span>, mit írjunk a weboldalra.
              </p>
              <p className="font-inter text-lg md:text-xl text-muted-text mt-4 max-w-2xl mx-auto relative z-10">
                Mi úgy írjuk meg, hogy a látogató a saját helyzetét lássa benne.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MitKapszSection;
